<template>
  <v-col class="pa-0">
    <v-row class="ma-0 pa-0">
      <v-col align="center" cols="8" offset="2">
        <h2 class="titleThanks">
          {{ activationTitle }}
        </h2>
        <v-icon
          size="20"
          class="ma-2 closeIcon"
          :disabled="!userActivated"
          @click="onCloseBtnClick"
        >
          ti-close
        </v-icon>
      </v-col>
    </v-row>
    <v-col align="center" v-if="!userActivated" justify="center" class="py-16">
      <v-progress-circular
        :size="70"
        :width="6"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-col>
    <v-col align="center" v-else justify="center" class="py-4">
      <!-- Activation failed -->
      <template v-if="errorMsg !== ''">
        <v-alert color="red" dense text type="error">
          {{ errorMsg }}
        </v-alert>
      </template>

      <!-- Activation succeeded -->
      <template v-else>
        <p class="pa-3">{{ $translate('USER_SUCCESS_ACTIVATED_DOWN') }}</p>
        <v-row justify="space-around" class="ma-0">
          <a :href="appStoreUrl" target="_blank" rel="noopener noreferrer">
            <v-img
              :src="require('@/assets/Download_on_the_App_Store.png')"
              width="120"
              class="mb-2"
              alt="Download on the App Store"
            />
          </a>
          <a :href="playStoreUrl" target="_blank" rel="noopener noreferrer">
            <v-img
              :src="require('@/assets/Download_on_the_Play_Store.png')"
              width="120"
              class="mb-2"
              alt="Get it on Google Play"
            />
          </a>
        </v-row>
        <v-col class="px-4">
          <v-btn
            color="primary"
            class="primary-font-color"
            depressed
            block
            large
            @click="closeDialog"
          >
            {{ $translate('CONTINUE') }}
          </v-btn>
        </v-col>
      </template>
    </v-col>
  </v-col>
</template>

<script>
import UserObject from '@/objects/UserObject';
import doRequest from '@/api/dssRequest';
import appConfig from '../../../config/app_config';
import uiHelpers from '../../shared/ui_helpers';

export default {
  name: 'AccountActivation',
  mixins: [uiHelpers],
  computed: {
    userMgrId() {
      const accountId =
        this.$store.getters['Account/partnerGroupDetails'].AccountId;
      if (accountId == null || accountId === '') {
        return null;
      }

      return `${accountId}_UM`;
    },
    appStoreUrl() {
      const pgInfo = this.$store.getters['Account/partnerGroupDetails'];
      if (pgInfo == null || pgInfo.AppleStoreListingUrl == null) {
        return '';
      }
      return pgInfo.AppleStoreListingUrl;
    },
    playStoreUrl() {
      const pgInfo = this.$store.getters['Account/partnerGroupDetails'];
      if (pgInfo == null || pgInfo.GoogleStoreListingUrl == null) {
        return '';
      }
      return pgInfo.GoogleStoreListingUrl;
    },
  },
  data() {
    return {
      activateObj: {},
      activationRequested: false,
      userActivated: false,
      userId: '',
      errorMsg: '',
      activationTitle: this.$translate('USER_PROGRESS_ACTIVATION'),
    };
  },
  watch: {
    userMgrId() {
      if (this.userMgrId != null && this.userMgrId !== '') {
        // Website initialized, activate user
        if (!this.activationRequested) {
          this.confirmRegistration();
          this.activationRequested = true;
        }
      }
    },
  },
  created() {},
  mounted() {
    if (this.userMgrId != null && this.userMgrId !== '') {
      // Website initialized, activate user
      if (!this.activationRequested) {
        this.confirmRegistration();
        this.activationRequested = true;
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('triggerPopup', { toggle: false, component: 'Activate' });
    },
    confirmRegistration() {
      if (this.$store.getters) this.activateObj = {};

      this.userId = this.$route.query.UserID;
      const partnerId =
        this.$route.query.PartnerId != null ? this.$route.query.PartnerId : -1;

      this.activateObj = UserObject._createActivateUserObject(
        appConfig.login.clientSecret,
        this.$route.query.email,
        this.$route.query.UserID,
        this.$route.query.token,
        partnerId
      );

      doRequest(
        (response) => {
          this.activationTitle = this.$translate('USER_SUCCESS_ACTIVATED');
          this.userActivated = true;

          this.$store.commit('auth/setUserName', this.userId);
          this.$store.commit('auth/setToken', response.data.access_token);
          this.$store.commit(
            'auth/setRefreshToken',
            response.data.refresh_token
          );

          if (partnerId && partnerId > -1) {
            this.$store.commit('setSavePartnerId', Number(partnerId));
            this.$store.commit('setRedirectedFromPearlCalendar', true);
          }
          this.$router.push({
            name: 'UserSettings',
            params: {
              userSettings: true,
            },
          });
        },
        (error) => {
          this.activationTitle = this.$translate('USER_ACTIVATION_FAILED');
          this.userActivated = true;
          this.errorMsg = this.$translateError(error.data.ErrorCode);
        },
        'activateUser',
        this.userMgrId,
        this.activateObj
      );
    },
    onCloseBtnClick() {
      this.$emit('triggerPopup', { toggle: false, component: 'Login' });
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.alertText {
  color: #2196f3;
}
.passwordDesc {
  font-size: 12px !important;
}
.closeIcon {
  position: absolute !important;
  top: 0;
  right: 0;
}
</style>
